import { GridColDef } from "@mui/x-data-grid";
import pathRoutes from "../../../routes/pathRoutes";
import { Edit, Remove } from "@app/components/Actions";
import dayjs from "dayjs";
import { MEDIO_FILTER_VALUE, TYPE_RESULT_TABLE } from "../utils/constans";
import { useBackground } from "./useBackground";
import { Chip } from "@mui/material";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "@app/pages/users/utils/helpers";

export const columnsBackground: GridColDef[] = [
  {
    field: "id",
    headerName: "ID. Fondo",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params: any) => <div>{params.row.id}</div>,
  },
  {
    field: "proceso",
    headerName: "Proceso",
    headerAlign: "center",
    align: "center",
    width: 150,
    renderCell: (params: any) => <div>{params.value}</div>,
    valueGetter: (params: any) => params.row.type,
  },
  {
    field: "mes",
    headerName: "Mes",
    headerAlign: "center",
    align: "center",
    width: 100,
    renderCell: (params: any) => {
      return <div>{params.value}</div>;
    },
    valueGetter: (params: any) => {
      const creationDate = params.row.creation_date;
      return creationDate ? dayjs(creationDate).format("MMMM") : "Sin fecha";
    },
  },
  {
    field: "anio",
    headerName: "Año",
    headerAlign: "center",
    align: "center",
    width: 100,
    renderCell: (params: any) => {
      return <div>{params.value}</div>;
    },
    valueGetter: (params: any) => {
      const creationDate = params.row.creation_date;
      return creationDate ? dayjs(creationDate).format("YYYY") : "Sin fecha";
    },
  },
  {
    field: "creation_date",
    headerName: "Fecha de creación",
    headerAlign: "center",
    align: "center",
    width: 100,
    renderCell: (params) => (
      <div className="flexCenter">
        {params.row.creation_date
          ? dayjs(params.row.creation_date).format("DD/MM/YYYY")
          : ""}
      </div>
    ),
  },
  {
    field: "calculation_date",
    headerName: "Fecha de cálculo",
    headerAlign: "center",
    align: "center",
    width: 100,
    renderCell: (params) => {
      const calculationDate = params.row.calculation_date;
      const formattedDate = calculationDate
        ? dayjs(calculationDate).format("DD/MM/YYYY")
        : "";
      return <div className="flexCenter">{formattedDate}</div>;
    },
  },
  {
    field: "equipo",
    headerName: "Equipo",
    headerAlign: "center",
    align: "center",
    width: 150,
    renderCell: (params: any) => <div>{params.value}</div>,
    valueGetter: (params: any) => params.row.equipment?.codigo,
  },
  {
    field: "filtro",
    headerName: "Filtro",
    headerAlign: "center",
    align: "center",
    width: 150,
    renderCell: (params: any) => {
      return <div>{params.value}</div>;
    },
    valueGetter: (params: any) => {
      const filtroValue = params.row.filter;
      const filtroText =
        filtroValue === MEDIO_FILTER_VALUE.MEDIO
          ? "Medio"
          : filtroValue === MEDIO_FILTER_VALUE.COMPLETO
          ? "Completo"
          : "";
      return filtroText;
    },
  },
  {
    field: "codigo_fondo",
    headerName: "Código Fondo",
    headerAlign: "left",
    align: "left",
    width: 150,
    renderCell: (params: any) => <div>{params.value}</div>,
    valueGetter: (params: any) => {
      return `${params.row.code?.proceso ?? ""} - ${
        params.row.code?.tipo_codigo ?? ""
      }
      ${params.row.filter ? ` - ${params.row.filter}` : ""}`;
    },
  },

  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => (
      <>
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Edit to={`${pathRoutes.ADMIN_FONDOS}/editar/${params.id}`} />
          <Remove
            onRemove={() => useBackground.getState().delete(params.id)}
            title="Va a borrar de forma permanente este informe"
            text="¿Quiere continuar?"
          />
        </PermissionComponentGate>
      </>
    ),
  },
];

export const columnsBackgroundInputs: GridColDef[] = [
  {
    field: "detector",
    headerName: "Detector",
    headerAlign: "center",
    align: "center",
    editable: false,
    flex: 1,
    renderCell: (params) => {
      const valueAsNumber = Number(params.value);
      const isValidNumber =
        !isNaN(valueAsNumber) &&
        !isNaN(parseFloat(params.value)) &&
        typeof valueAsNumber === "number";

      return (
        <div style={{ color: isValidNumber ? "inherit" : "red" }}>
          {isValidNumber ? valueAsNumber : params.value}
        </div>
      );
    },
  },
  {
    field: "cpm1",
    headerName: "cpm1",
    headerAlign: "center",
    align: "center",
    editable: true,
    flex: 1,
    renderCell: (params) => {
      const valueAsNumber = Number(params.value);
      const isValidNumber =
        !isNaN(valueAsNumber) &&
        !isNaN(parseFloat(params.value)) &&
        typeof valueAsNumber === "number";

      return (
        <div style={{ color: isValidNumber ? "inherit" : "red" }}>
          {isValidNumber ? valueAsNumber : params.value}
        </div>
      );
    },
  },
  {
    field: "cpm2",
    headerName: "cpm2",
    headerAlign: "center",
    align: "center",
    editable: true,
    flex: 1,
    renderCell: (params) => {
      const valueAsNumber = Number(params.value);
      const isValidNumber =
        !isNaN(valueAsNumber) &&
        !isNaN(parseFloat(params.value)) &&
        typeof valueAsNumber === "number";

      return (
        <div style={{ color: isValidNumber ? "inherit" : "red" }}>
          {isValidNumber ? valueAsNumber : params.value}
        </div>
      );
    },
  },
  {
    field: "cpm3",
    headerName: "cpm3",
    headerAlign: "center",
    align: "center",
    editable: true,
    flex: 1,
    renderCell: (params) => {
      const valueAsNumber = Number(params.value);
      const isValidNumber =
        !isNaN(valueAsNumber) &&
        !isNaN(parseFloat(params.value)) &&
        typeof valueAsNumber === "number";

      return (
        <div style={{ color: isValidNumber ? "inherit" : "red" }}>
          {isValidNumber ? valueAsNumber : params.value}
        </div>
      );
    },
  },
  {
    field: "cpm4",
    headerName: "cpm4",
    headerAlign: "center",
    align: "center",
    editable: true,
    flex: 1,
    renderCell: (params) => {
      const valueAsNumber = Number(params.value);
      const isValidNumber =
        !isNaN(valueAsNumber) &&
        !isNaN(parseFloat(params.value)) &&
        typeof valueAsNumber === "number";

      return (
        <div style={{ color: isValidNumber ? "inherit" : "red" }}>
          {isValidNumber ? valueAsNumber : params.value}
        </div>
      );
    },
  },
];

export const columnsBackgrounResultdInputs: GridColDef[] = [
  {
    field: "media",
    headerName: "Media",
    headerAlign: "center",
    align: "center",
    editable: false,
    flex: 1,
    renderCell: (params) => {
      const valueAsNumber = Number(params.value);
      const isValidNumber =
        !isNaN(valueAsNumber) &&
        !isNaN(parseFloat(params.value)) &&
        typeof valueAsNumber === "number";

      return (
        <div style={{ color: isValidNumber ? "inherit" : "red" }}>
          {isValidNumber ? valueAsNumber.toFixed(3) : params.value}
        </div>
      );
    },
  },
  {
    field: "reference_value",
    headerName: "Valor ref.",
    headerAlign: "center",
    align: "center",
    editable: false,
    flex: 1,
    renderCell: (params) => {
      const valueAsNumber = Number(params.value);
      const isValidNumber =
        !isNaN(valueAsNumber) &&
        !isNaN(parseFloat(params.value)) &&
        typeof valueAsNumber === "number";

      return (
        <div style={{ color: isValidNumber ? "inherit" : "red" }}>
          {isValidNumber ? valueAsNumber.toFixed(3) : params.value}
        </div>
      );
    },
  },
  {
    field: "variation",
    headerName: "Variación % ",
    headerAlign: "center",
    align: "center",
    editable: false,
    flex: 1,
    renderCell: (params) => {
      const valueAsNumber = Number(params.value);
      const isValidNumber =
        !isNaN(valueAsNumber) &&
        !isNaN(parseFloat(params.value)) &&
        typeof valueAsNumber === "number";

      return (
        <div style={{ color: isValidNumber ? "inherit" : "red" }}>
          {isValidNumber ? valueAsNumber : params.value}
        </div>
      );
    },
  },
  {
    field: "result",
    headerName: "Resultado",
    headerAlign: "center",
    align: "center",
    editable: false,
    flex: 1,
    renderCell: (params) => {
      const result = params.value;
      const backgroundColor =
        result === TYPE_RESULT_TABLE.KEEP
          ? "green"
          : result === TYPE_RESULT_TABLE.CHANGE
          ? "red"
          : "inherit";

      return params.value ? (
        <Chip label={result} style={{ backgroundColor, color: "white" }} />
      ) : null;
    },
  },
  {
    field: "value_to_apply",
    headerName: "Valor aplicar",
    headerAlign: "center",
    align: "center",
    editable: false,
    flex: 1,
    renderCell: (params) => {
      const valueAsNumber = Number(params.value);
      const isValidNumber =
        !isNaN(valueAsNumber) &&
        !isNaN(parseFloat(params.value)) &&
        typeof valueAsNumber === "number";

      return (
        <div style={{ color: isValidNumber ? "inherit" : "red" }}>
          {isValidNumber ? valueAsNumber.toFixed(3) : params.value}
        </div>
      );
    },
  },
];

export const columnsGammaForm = (handleDeleteRow) => [
  {
    field: "isotope_instalation",
    headerName: "Isótopo",
    flex: 1,
    renderCell: (params) => {
      return <div>{params.row.isotope_instalation.codigo}</div>;
    },
  },
  { field: "energy", headerName: "Energía (Kev)", flex: 1 },
  {
    field: "fondo_integral_reference",
    headerName: "Fondo Integral Ref",
    flex: 1,
  },
  {
    field: "fondo_integral_current_reference",
    headerName: "Fondo Integral Actual",
    flex: 1,
  },
  {
    field: "fondo_integral_current_reference_calculated",
    headerName: "Fondo Integral Actual (cps)",
    flex: 1,
  },
  { field: "fondo_integral", headerName: "Fondo Integral (%var)", flex: 1 },
  { field: "lid_variation", headerName: "Variación (%) LID", flex: 1 },
  {
    field: "fondo_area_reference",
    headerName: "Fondo Área Ref (cps)",
    flex: 1,
  },
  {
    field: "fondo_area_reference_error",
    headerName: "Error Fondo Área Ref (cps)",
    flex: 1,
  },
  {
    field: "fondo_area_current_counts",
    headerName: "Fondo Área Actual (cuentas)",
    flex: 1,
  },
  {
    field: "fondo_area_current_cps",
    headerName: "Fondo Área Actual (cps)",
    flex: 1,
  },
  {
    field: "fondo_area_error",
    headerName: "Error Fondo Área (cps)",
    flex: 1,
  },
  {
    field: "fondo_area_variation",
    headerName: "Variación Fondo Área",
    flex: 1,
  },
  {
    field: "fondo_integration_to_apply",
    headerName: "A aplicar Fondo Integral (cps)",
    flex: 1,
  },
  {
    field: "fondo_area_to_apply",
    headerName: "A aplicar Fondo Área (cps)",
    flex: 1,
  },
  {
    field: "fondo_area_error_to_apply",
    headerName: "A aplicar Error Fondo Área (cps)",
    flex: 1,
  },
  {
    field: "actions",
    headerName: "Acciones",
    flex: 1,
    renderCell: (params) =>
      !useBackground.getState().loading && (
        <Remove
          onRemove={() => handleDeleteRow(params.row.id)}
          title="Va a borrar la fila"
          text="¿Quiere continuar?"
        />
      ),
  },
];
